import React, { Component, Suspense, Fragment } from "react";
import ContentLoader from "react-content-loader";
import { IconButton, Collapse, Grid, Alert, Icon } from '@mui/material';
import { withRouter } from "../../../services/withRouter";
import LoadingSkeletonModule from "../../../components/common/LoadingSkeletonModule";

class DashboardCardViews extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true,
      showAlert: true,
      userData: {},
      statusLogin: false,
      card: []
    };
  }

  dashboardCardType = () => {
    const { card, views, id } = this.props.router.params;
    let cardName = card.charAt(0).toUpperCase() + card.slice(1);

    let ComponentLazy;

    if (cardName === "Coupon" || cardName === "Bookings") {
      ComponentLazy = React.lazy(() =>
        import(`../../forms/View${cardName}${views === "create" ? "Create" : ""}`)
      );
    } else {
      ComponentLazy = React.lazy(() =>
        import(`../../forms/View${cardName}`)
      );
    }

    return (
      <Suspense fallback={
        <LoadingSkeletonModule />
      }>
        <ComponentLazy card={card} views={views} id={id} />
      </Suspense>
    );
  };

  collapseAlert = () => {
    this.setState({ open: !this.state.open, showAlert: false });
  };
  componentDidMount() {
    // Google Tag Manager
    // const scriptGoogle = document.createElement("script");
    // scriptGoogle.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    // new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    // j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    // 'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    // })(window,document,'script','dataLayer','${process.env.REACT_APP_GOOGLE_TAG_MANAGER}');`;
    // document.head.appendChild(scriptGoogle);

    // const noscriptGoogleTagManager = document.createElement("noscript");
    // const iframe = document.createElement("iframe");
    // iframe.src = "https://www.googletagmanager.com/ns.html?id=" + process.env.REACT_APP_GOOGLE_TAG_MANAGER;
    // iframe.height = "0";
    // iframe.width = "0";
    // iframe.style.display = "none";
    // iframe.style.visibility = "hidden";
    // noscriptGoogleTagManager.appendChild(iframe);
    // document.head.appendChild(noscriptGoogleTagManager);
  }

  render() {
    const { card } = this.props.router.params;
    const { location } = this.props.router;

    return (
      <Fragment>
        <Grid container spacing={3}>
          <Grid item md={12}>
            <div className={`detail_dashboard dashboard_card_expanded DashboardCardViews ${card}`}>
              <div className="content_detail_dashboard">
                {location.state?.stepFinalizado !== undefined && location.state.view !== "show" && (
                  <Collapse in={true} className="alertTopCardContent">
                    <Alert
                      severity="info"
                      variant="filled"
                      action={
                        <IconButton aria-label="close" color="inherit" size="small">
                          <Icon className="material-symbols-outlined">close</Icon>
                        </IconButton>
                      }
                    >
                      {location.state.view === "edit"
                        ? "El producto se actualizó correctamente"
                        : "El producto se creó correctamente"}
                    </Alert>
                  </Collapse>
                )}
                {location.state?.responseEdit !== undefined && (
                  <Alert
                    severity="info"
                    variant="filled"
                    action={
                      <IconButton aria-label="close" color="inherit" size="small">
                        <Icon className="material-symbols-outlined">close</Icon>
                      </IconButton>
                    }
                  >
                    {location.state.responseEdit}
                  </Alert>
                )}
                {this.dashboardCardType()}
              </div>
            </div>
          </Grid>
        </Grid>
      </Fragment>
    );
  }
}

export default withRouter(DashboardCardViews);
